import { CalibrationPointsConfig } from '../../sensors/types';
import {
  createBasicFieldsObject,
  createTemperatureFieldsObject,
  clearCalibrationPointFields,
} from './fieldHelpers';


export type CalibrationFieldMap = Record<string, string>;

export const initializeCalibrationDataFields = (
  points?: CalibrationPointsConfig
): CalibrationFieldMap => {

  const DEFAULT_POINTS: CalibrationPointsConfig = {
    increasing: [10, 20, 30, 40, 50],
    decreasing: [40, 30, 20, 10, 0],
    secondIncreasing: [10, 20, 30, 40, 50]
  };

  const calibrationPoints = points || DEFAULT_POINTS;

  const fields: CalibrationFieldMap = {
    sensorId: "",
    sensorType: "",
    category: "",
    modelFamily: "",
    model: "",
    range: "",
    calibrationFactor: "",
    temperatureCoefficient: "",
    baselineFrequency: "",
    notes: "",
    // Additional category-specific fields
    ambientTemp: "",
    atmPressure: "",
    dwtTraceable: "",
    ...createBasicFieldsObject(),
    ...createTemperatureFieldsObject(),
  };

  clearCalibrationPointFields(calibrationPoints, fields);

  return fields;
};
